import { WalletOffers } from "./wallet-offers";

export class WalletPayment {

    refNo: string;
    amount: number = 0;
    fromLocationCode: number;
    type: string;

    appliedOfferList: WalletOffers[] = [];
}
